import { CommonModule, formatNumber } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ToastrService } from 'ngx-toastr';
import { AddReceipe } from '../../models/add-receipe';
import { RecipeService } from '../../services/recipe.service';

const EVAPORATING_INGREDIENTS = [
  'Milk, whole, Buffalo',
  'Milk, whole, Cow',
  'Milk fish',
  'Water',
  'coconut milk',
  'Almond milk'
];

@Component({
  selector: 'app-update-recipe',
  standalone: true,
  imports: [FormsModule, CommonModule, AngularEditorModule],
  templateUrl: './update-recipe.component.html',
  styleUrls: ['./update-recipe.component.css']
})
export class UpdateRecipeComponent {
  recipe: AddReceipe = {
    recipeName: '',
    shortDescription: '',
    normalizeRecipeName: '',
    recipeImageUpload: '',
    referenceLink: '',
    note: '',
    ingredients: [],
    allergies: [],
    diets: [],
    
    preparationSteps: [],
    createdBy: 0,
    totalCals: 0,
    totalProtien: 0,
    totalFats: 0,
    totalCarbs: 0,
    recipeType: '',
    evaporate: 0,
    totalMeasure: 0
  };

  editorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    svgPath: 'assets/ae-icons/icons.svg',
    placeholder: 'Enter short description...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    toolbarHiddenButtons: [[], []],
    toolbarPosition: 'top',
    defaultFontName: 'Arial',
    sanitize: true,
    showToolbar: true
  };

  recipeType: string[] = [
    'Mediterranean Diet',
    'Low-Carb Diet',
    'Intermittent Fasting',
    'Paleo Diet',
    'Vegan Diet',
    'Raw Food Diet',
    'Ketogenic Diet'
  ];

  cols = [
    { field: 'Ingredients', header: 'Ingredients' },
    { field: 'Qty', header: 'Qty' },
    { field: 'Note', header: 'Note' },
    { field: 'cals', header: 'Cals' },
    { field: 'protein', header: 'Protein' },
    { field: 'carbs', header: 'Carbs' },
    { field: 'fat', header: 'Fat' },
    { field: 'action', header: 'Action' }
  ];

  rows: any[] = [];
  rowStep: any[] = [];
  ingredientList: any[] = [];
  allergies: string[] = [
    'Gluten', 'Dairy', 'Eggs', 'Soy', 'Wheat', 'Fish',
    'Shellfish', 'Tree Nuts', 'Peanuts'
  ];

  diets: string[] = [
    'Hindu Vegetarian', 'Hindu Non-Veg', 'Non Vegetarian',
    'Pescatarian', 'Eggetarian', 'Jain', 'Lacto-Vegetarian',
    'Vegan', 'Halal', 'Low Fat', 'Low Cholesterol', 'Low Sodium',
    'Gluten Intolerant', 'Paleo', 'High Fiber', 'High Protein',
    'Low Carb', 'Low Sugar'
  ];

  timeout: any = null;
  searchIngredientResult: any[] = [];
  showPleaseText = true;
  measureUnit!: string;
  selectedTypes: any[] = [];
  file!: File;
  fileName = '';
  steps: any[] = [];
  recipeId: any;
  isUpdate = false;

  constructor(
    private recipeService: RecipeService,
    private toastr: ToastrService,
    private route: ActivatedRoute
  ) {}

 ngOnInit(): void {
  const recipeId = this.route.snapshot.paramMap.get('id');
  if (!recipeId) {
    this.toastr.error('No recipe ID found in the route.');
    return;
  }
  this.recipeId = recipeId;

  this.recipeService.getRecipeById(recipeId).subscribe((data: any) => {
  this.recipe = {
    ...data,
    diets: this.parseStringToArray(data.diets),
    allergies: this.parseStringToArray(data.allergies)
  };

    this.ingredientList = Object.values(data.ingredients || {});
    this.steps = Array.isArray(data.preparationSteps) ? data.preparationSteps : [];

    for (const ing of this.ingredientList) {
      const realCals = this.macro(ing, 'Cals') / 100;
      const realProtein = this.macro(ing, 'Protein') / 100;
      const realCarbs = this.macro(ing, 'Carbs') / 100;
      const realFat = this.macro(ing, 'Fats') / 100;
      const measureVal = ing.measureUnitValue || 1;

      this.rows.push({
        ingredientId: ing.ingredientId,
        ingredientName: ing.ingredientName,
        qty: ing.qty,
        measureunit: [measureVal],
        realCals,
        cals: formatNumber(ing.qty * realCals * measureVal, 'en-US', '1.0-2'),
        realProtein,
        protein: formatNumber(ing.qty * realProtein * measureVal, 'en-US', '1.0-2'),
        realCarbs,
        carbs: formatNumber(ing.qty * realCarbs * measureVal, 'en-US', '1.0-2'),
        realFat,
        fat: formatNumber(ing.qty * realFat * measureVal, 'en-US', '1.0-2'),
        measure: ing.measureUnit,
        measureUnit: ing.measureUnit,
        measurement: [ing.measureUnit],
        measurementUnitValue: measureVal,
        ingredientType: ing.ingredientType,
        searchIngredents: [],
        isSearchBoxShow: false,
        checkUpdate: 1
      });
    }

    this.rowStep = [];
    for (const step of this.steps) {
      if (typeof step === 'string') {
        this.rowStep.push({ step: '', description: step });
      } else if (typeof step === 'object' && step !== null) {
        this.rowStep.push({
          step: step.step || '',
          description: step.description || ''
        });
      }
    }

   
    this.recipeService.getDiets().subscribe((res: any) => {
  const apiTags = res.tags.map((tag: any) => tag.tagName);
  this.diets = Array.from(new Set([
    ...(this.recipe.diets || []),
    ...(this.diets || []),
    ...apiTags
  ]));
  console.log(" Final Diets List:", this.diets);
});


    this.recipeService.getAllergies().subscribe((res: any) => {
  const apiTags = res.tags.map((tag: any) => tag.tagName);
  this.allergies = Array.from(new Set([
    ...(this.recipe.allergies || []),
    ...(this.allergies || []),
    ...apiTags
  ]));
  console.log("Final Allergy List:", this.allergies);
});

  });
}


parseStringToArray(val: any): string[] {
  if (Array.isArray(val)) return val;
  if (typeof val === 'string') {
    try {
      const parsed = JSON.parse(val);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
}


  private macro(ingredient: any, key: 'Cals' | 'Protein' | 'Fats' | 'Carbs'): number {
    const obj = ingredient[key] ?? ingredient[key.toLowerCase()];
    const raw = obj?.value ?? obj?.Value;
    return raw ? Number(raw) : 0;
  }

  addRow() {
    this.isUpdate = true;
    this.rows.push({
      id: this.rows.length + 1,
      name: '',
      searchIngredents: [],
      isSearchBoxShow: false,
      ingredientName: '',
      measureunit: [],
      realCals: '0',
      realProtein: '0',
      realCarbs: '0',
      realFat: '0',
      measure: '',
      measurement: [],
      measurementUnitValue: '',
      ingredientType: '',
      checkUpdate: 2
    });
  }

  deleteRow(row: any) {
    const index = this.rows.indexOf(row);
    if (index > -1) {
      this.rows.splice(index, 1);
    }
  }

  deleteRowStep(step: any) {
    const index = this.rowStep.indexOf(step);
    if (index > -1) {
      this.rowStep.splice(index, 1);
    }
  }
addStepRow() {
  let indexForId = this.rowStep.length + 1
  this.rowStep.push({
    step:'',
      description:''
  });
}

onChange(event:any) {
  //console.log(event.target.files);
  this.recipe.recipeImageUpload = event.target.files[0];

}
  onAdd(item:any) {
 
    console.log('tag added: value is ' + item.value);
  }
  
   onRemove(item:any) {
    console.log('tag removed: value is ' + item.value);
  }
  onSelect(item:any) {
    console.log('tag selected: value is ' + item);
  }
   onTagEdited(item:any) {
    console.log(item);
    console.log('tag edited: current value is ' + item.tag);
  }

//   selectedType(data:any){
//     this.selectedTypes.push(data);
// }

selectedTags(data:any,name:any,type:any){
  if(data.target.checked == true){
    if(type == 1){
      this.recipe.diets.push(name);
    }else{
      this.recipe.allergies.push(name);
    }
    
  }else{
    if(type == 1){
      const index = this.recipe.diets.indexOf(name);
      this.recipe.diets.splice(index, 1);
    }else{
      const index = this.recipe.allergies.indexOf(name);
      this.recipe.allergies.splice(index, 1);
    }
  }
    console.log( this.selectedTypes);
}

public searchIngredent(event: any,index:any) {
  clearTimeout(this.timeout);
  var $this = this;
  if(event.target.value != ''){
  this.timeout = setTimeout(function () {
    if (event.keyCode != 13) {
      $this.executeListing(event.target.value,index);
    }
  }, 500);
}else{
  this.rows[index].isSearchBoxShow=false;
}
}

private executeListing(value: string,index:any) {
  this.rows[index].isSearchBoxShow=true;
  this.showPleaseText=true;
  this.recipeService.searchIngredient(value).subscribe((response:any) => {    
    //this.searchIngredientResult = response;
    this.showPleaseText=false;
    this.rows[index].searchIngredents=response;
    //console.log(response[0].cals['value']);
    
  });
}
blurTextbox(index:any){
  this.rows[index] = [];
  this.rows[index].isSearchBoxShow=false;
}
 selectedIngredent(title: any, id: any, index: number, data: any) {
  this.isUpdate = true;

  
  this.rows[index].ingredientName  = title;
  this.rows[index].food            = title;
  this.rows[index].ingredientId    = id;
  this.rows[index].isSearchBoxShow = false;

  
  this.rows[index].realCals    = this.macro(data, 'Cals')    / 100;
  this.rows[index].realProtein = this.macro(data, 'Protein') / 100;
  this.rows[index].realCarbs   = this.macro(data, 'Carbs')   / 100;
  this.rows[index].realFat     = this.macro(data, 'Fats')    / 100;

  this.rows[index].cals    = this.macro(data, 'Cals').toString();
  this.rows[index].protien = this.macro(data, 'Protein').toString();
  this.rows[index].carbs   = this.macro(data, 'Carbs').toString();
  this.rows[index].fat     = this.macro(data, 'Fats').toString();

  this.rows[index].qty         = 1;      
  this.rows[index].checkUpdate = 2;      

 
  this.calculateMeasure(data.ingredientType, index);   

  
  const first = this.rows[index].measurement[0];
  this.rows[index].measure              = first;
  this.rows[index].measurementUnitValue = this.rows[index].measureunit[first];

 
  this.addUnit(null, index, 1);
}

addUnit(unit:any,index:any,type:any){
  
  if(type == 1){
    var unit =  this.rows[index].qty;
  }else{
    var unit = unit.target.value;
  }
  if(unit == ''){
    unit = 1;
  }
  
  if(this.rows[index].ingredientName != '' && unit> 0  && unit != ''){
    let measure = this.rows[index].measure;
    let measureVal = this.rows[index].measureunit[measure];
    if(measureVal == undefined){
      measureVal = this.rows[index].measurementUnitValue;
    }else{
      this.rows[index].measurementUnitValue = measureVal;
    }
    //this.rows[index].measurementUnitValue = measureVal;
    console.log(this.rows[index].measurementUnitValue);
    console.log(unit);
    let cals;
    let protien;
    let fat;
    let carbs;
    if(measure == 'Small Piece' || measure == 'Medium Piece' ||  measure == 'Large Piece'){
       cals = this.rows[index].realCals; 
        protien = this.rows[index].realProtein;
        carbs = this.rows[index].realCarbs;
        fat = this.rows[index].realFat;
    }else{
      
      // cals = this.rows[index].realCals/100; 
      // protien = this.rows[index].realProtein/100;
      // carbs = this.rows[index].realCarbs/100;
      // fat = this.rows[index].realFat/100;

      cals = this.rows[index].realCals; 
      protien = this.rows[index].realProtein;
      carbs = this.rows[index].realCarbs;
      fat = this.rows[index].realFat;
    }
    this.rows[index].cals=formatNumber(unit*cals*measureVal,'en-US', '1.0-2');

   this.recipe.totalCals = this.rows.reduce((accumulator: number, object: any) => {
  const val = parseFloat((object.cals || '0').replace(/,/g, ''));
  return accumulator + (isNaN(val) ? 0 : val);
}, 0);

   
    this.recipe.totalProtien = this.rows.reduce((acc: number, obj: any) => {
  const val = parseFloat((obj.protein || '0').replace(/,/g, ''));
  return acc + (isNaN(val) ? 0 : val);
}, 0);


    
    this.rows[index].carbs=formatNumber(unit*carbs*measureVal,'en-US', '1.0-2');

    this.recipe.totalCarbs = this.rows.reduce((acc: number, obj: any) => {
  const val = parseFloat((obj.carbs || '0').replace(/,/g, ''));
  return acc + (isNaN(val) ? 0 : val);
}, 0);

    
    this.rows[index].fat=formatNumber(unit*fat*measureVal,'en-US', '1.0-2');

   this.recipe.totalFats = this.rows.reduce((acc: number, obj: any) => {
  const val = parseFloat((obj.fat || '0').replace(/,/g, ''));
  return acc + (isNaN(val) ? 0 : val);
}, 0);

  }
  
}
onFilechange(event: any) {   
    
  this.file = event.target.files[0];
  this.fileName = event.target.files[0].name;
}
removeComma() {
  this.recipe.totalCals = parseFloat((this.recipe.totalCals + '').replace(/,/g, ''));
}


updateReceipe() {
  const now = new Date().toISOString();
  this.recipe.totalMeasure = 0;
  this.ingredientList = [];

  // Format preparation steps
  this.recipe.preparationSteps = this.rowStep
    .filter(step => step?.description?.trim())
    .map((step, idx) => ({
      step: `Step ${idx + 1}`,
      description: step.description
    }));

  for (let i = 0; i < this.rows.length; i++) {
    const row = this.rows[i];

    if (!row.ingredientId && !row.ingredientName && !row.qty && !row.measure) continue;

    if (!row.ingredientId || !row.ingredientName || !row.qty || !row.measure) {
      this.toastr.error(`Please complete all fields for ingredient row ${i + 1}.`);
      return;
    }

    const qty = Number(row.qty);
    const unitValue = Number(row.measurementUnitValue);

    if (!qty || isNaN(qty) || qty <= 0) {
      this.toastr.error(`Invalid quantity at row ${i + 1}.`);
      return;
    }

    if (!unitValue || isNaN(unitValue)) {
      this.toastr.error(`Invalid unit at row ${i + 1}.`);
      return;
    }

    const isLiquid = row.ingredientType === 'Liquid';
    const specialLiquids = [
      'Milk, whole, Buffalo', 'Milk, whole, Cow', 'Milk fish',
      'Water', 'coconut milk', 'Almond milk'
    ];

    let calValue = unitValue;
    if (isLiquid && specialLiquids.includes(row.ingredientName)) {
      const evap = Number(this.recipe.evaporate);
      if (!evap || evap < 1 || isNaN(evap)) {
        this.toastr.error('Please enter a valid evaporate % (e.g., 10)');
        return;
      }
      calValue = unitValue - (evap * unitValue) / 100;
    }

    this.recipe.totalMeasure += calValue;

    this.ingredientList.push({
      ingredientId: row.ingredientId,
      ingredientName: row.ingredientName,
      ingredientCode: row.ingredientCode || '',
      ingredientDescription: row.ingredientDescription || '',
      ingredientType: row.ingredientType || '',
      qty,
      recipeQuantity: qty,
      measureUnit: row.measure,
      measureUnitValue: unitValue,
      cals: { value: row.Cals || '0', type: 'kcal' },
      protien: { value: row.Protien || '0', type: 'g' },
      fats: { value: row.Fats || '0', type: 'g' },
      carbs: { value: row.Carbs || '0', type: 'g' },
      fibre: { value: row.Fibre || '0', type: row.FibreType || 'g' },
      calcium: { value: row.Calcium || '0', type: row.CalciumType || 'mg' },
      iron: { value: row.Iron || '0', type: row.IronType || 'mg' },
      zinc: { value: row.Zinc || '0', type: row.ZincType || 'mg' },
      potassium: { value: row.Potassium || '0', type: row.PotassiumType || 'mg' },
      sodium: { value: row.Sodium || '0', type: row.SodiumType || 'mg' },
      vitaminA: { value: row.VitaminA || '0', type: row.VitaminAType || 'mcg' },
      vitaminC: { value: row.VitaminC || '0', type: row.VitaminCType || 'mg' },
      omega3: { value: row.Omega3 || '0', type: row.Omega3Type || 'mg' },
      diet: row.Diet ?? [],
      allergies: row.Allergies ?? [],
      status: 'Active',
      addedBy: this.recipeService.getLoggedUser().id.toString(),
      createdDateTime: this.recipe.createdDateTime || now,
      modifiedDateTime: now
    });
  }

  if (!this.recipe.recipeName?.trim()) {
    this.toastr.error('Recipe name is required.');
    return;
  }

  this.recipe.ingredients = this.ingredientList;
  this.recipe.totalCals = Number(this.recipe.totalCals || 0);
  this.recipe.totalCarbs = Number(this.recipe.totalCarbs || 0);
  this.recipe.totalFats = Number(this.recipe.totalFats || 0);
  this.recipe.totalProtien = Number(this.recipe.totalProtien || 0);
  this.recipe.evaporate = Number(this.recipe.evaporate || 0);
  this.recipe.modifiedDateTime = now;

  const finalPayload: any = {
    ...this.recipe,
    normalizeRecipeName: this.recipe.recipeName?.toLowerCase().trim() || '',
    preparationSteps: this.recipe.preparationSteps,
    diets: this.recipe.diets || [],
    allergies: this.recipe.allergies || [],
    ingredients: this.ingredientList,
  };

  const sendUpdate = (payload: any) => {
    this.recipeService.updateRecipe({ recipe: payload }, this.recipeId).subscribe({
      next: () => {
        this.toastr.success('Recipe updated successfully.');
        setTimeout(() => window.location.href = '/recipes', 500);
      },
      error: (err) => {
        console.error(' Update failed:', err);
        this.toastr.error(err?.error?.message || 'Update error.');
      }
    });
  };

  if (!this.file) {
    sendUpdate(finalPayload);
  } else {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = (reader.result as string).split(',')[1];
      finalPayload.recipeImageUpload = base64;
      sendUpdate(finalPayload);
    };
    reader.readAsDataURL(this.file);
  }

  console.log(' Final Update Payload:', finalPayload);
}


checkTagSelected(val:any,type:any){
  let key = 0;
  if(type == 1){
     key = this.recipe.diets.indexOf(val);
  }else{
     key = this.recipe.allergies.indexOf(val);
  }
  
  if (key < 0) {
    return false;
  }else{
    return true;
  }
  
}



calculateMeasure(ingredientType:any,index:any){
  console.log(ingredientType);
  console.log(index);
  let measure = this.recipeService.getAllMeasure();
   this.measureUnit ='g';
   
   if(ingredientType == 'Egg'){
      this.rows[index].measurement = measure[0];
      this.rows[index].measureunit = measure[7][0];
       }
   else if(ingredientType == 'Liquid'){
      this.rows[index].measurement = measure[1];
      this.rows[index].measureunit = measure[8][0];
      this.measureUnit ='ml';
    }
    else if(ingredientType == 'Solid'){
      this.rows[index].measurement = measure[3];
      this.rows[index].measureunit = measure[10][0];
    }
    else if(ingredientType == 'Semisolid'){
      this.rows[index].measurement = measure[4];
      this.rows[index].measureunit = measure[11][0];
    }
    else if(ingredientType == 'Semiliquid'){
      this.rows[index].measurement = measure[2];
      this.rows[index].measureunit = measure[9][0];
    }
    else if(ingredientType == 'Oil'){
      this.rows[index].measurement = measure[5];
      this.rows[index].measureunit = measure[12][0];
    }

    
    else if(ingredientType == 'Meat'){
      this.rows[index].measurement = measure[6];
      this.rows[index].measureunit = measure[13][0];
    }

}
}